import { render, staticRenderFns } from "./PostalCodeField.vue?vue&type=template&id=436aa61c&scoped=true&"
import script from "./PostalCodeField.vue?vue&type=script&lang=js&"
export * from "./PostalCodeField.vue?vue&type=script&lang=js&"
import style0 from "./PostalCodeField.vue?vue&type=style&index=0&id=436aa61c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436aa61c",
  null
  
)

export default component.exports